const Errors = {
  'ALREADY_SIGN_UP': 'already_sign_up',
  'VERIFY_EMAIL': 'verify_email',
  password_incorrect: 'password_incorrect',
  'USERNAME_EXIST': 'username_exist',
  'ALREADY_FRIEND': 'already_friend'
}

export default Errors;